import { Button } from '@repo/ui/button'
import { Alert, AlertDescription, AlertTitle } from '@repo/ui/alert'
import { Card, CardContent, CardHeader, CardTitle } from '@repo/ui/card'
import { Input } from '@repo/ui/input'
import { postBackofficeAuthSignInWithEmail } from '@repo/sdk/gen'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { CircleAlert } from 'lucide-react'
import { useState } from 'react'

export const Route = createFileRoute('/login')({
	ssr: false,
	component: LoginPage
})

function LoginPage() {
	const navigate = useNavigate()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState<string | null>(null)
	const [isSubmitting, setIsSubmitting] = useState(false)

	async function signIn(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault()
		setError(null)
		setIsSubmitting(true)
		try {
			const response = await postBackofficeAuthSignInWithEmail({
				body: { email, password }
			})
			if (response.data.status === 'success') {
				navigate({ to: '/' })
				return
			}
			navigate({ to: '/mfa' })
			return
		} catch {
			setError('Unable to sign in with those credentials.')
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<main className='grid min-h-screen place-items-center bg-background p-5'>
			<Card className='w-full max-w-md rounded-2xl'>
				<CardHeader>
					<CardTitle>Seal Ledger Backoffice</CardTitle>
				</CardHeader>
				<CardContent>
					<form className='space-y-4' onSubmit={signIn}>
						<Input
							aria-label='Email'
							autoComplete='email'
							onChange={(event) => setEmail(event.target.value)}
							placeholder='Email'
							type='email'
							value={email}
						/>
						<Input
							aria-label='Password'
							autoComplete='current-password'
							onChange={(event) =>
								setPassword(event.target.value)
							}
							placeholder='Password'
							type='password'
							value={password}
						/>
						{error ? (
							<Alert variant='destructive'>
								<CircleAlert />
								<AlertTitle>Unable to sign in</AlertTitle>
								<AlertDescription>{error}</AlertDescription>
							</Alert>
						) : null}
						<Button
							className='w-full'
							disabled={isSubmitting}
							type='submit'
						>
							{isSubmitting ? 'Signing in…' : 'Sign in'}
						</Button>
					</form>
				</CardContent>
			</Card>
		</main>
	)
}
